// 3rd party
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
  styleUrls: ['./unauthorized-page.component.css']
})

export class UnauthorizedPageComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pages/error/unauthorized-page.component.ts